import * as React from 'react'
import { Input } from 'reactstrap';
import { accentUtils, format, t } from '../../services/HelperService';
import { AccentSpinner } from '../AccentSpinner';

export class TrackingNotes extends React.Component {

    constructor(props) {
        super(props);

        this.clearNoteKey = 0;

        this.state = {
            showNewNote: false
        };

        this.onBlur = this.onBlur.bind(this);
        this.keyPress = this.keyPress.bind(this);
        this.onNewClick = this.onNewClick.bind(this);
    }

    onBlur() {
        this.setState({ showNewNote: false });

    }

    onNewClick() {
        this.setState({ showNewNote: true });
    }

    keyPress(event) {
        if (event.charCode === 13) {
            var val = event.currentTarget.value

            if (!accentUtils.isEmpty(val)) {
                this.props.onNew(val);
                this.setState({ showNewNote: false });
            }
        }
    }


    render() {


        if (!this.props.show)
            return null;



        if (accentUtils.isNull(this.props.notes)) {
            return <tr className="trackingNotesRow">
                <td colSpan={this.props.cols}><AccentSpinner /></td>
            </tr>;
        }

        var alerts = null;
        if (!accentUtils.isNull(this.props.alerts)) {
            alerts = this.props.alerts.map((a, ix) => {
                return <div key={ix} className="accentTrackingNoteAlert">{a}</div>;
            });
        }





        var fileNotes = null;
        if (!accentUtils.isNull(this.props.notes)) {
            fileNotes = this.props.notes.map(function (n) {
                return <div key={n.ID} className="accentTrackingNoteFileNote">
                    <div>{format.formatDateTime(n.Date, true, true) + ' ' + n.FullName}</div>
                    <div dangerouslySetInnerHTML={{ __html: n.Notes }} />
                </div>;
            });
        }
        var newNote = null;

        if (this.state.showNewNote) {
            newNote = <Input onBlur={this.onBlur} onKeyPress={this.keyPress} key={this.clearNoteKey} type="text" placeholder={t("application_strings.views.tracking.newNotePlaceholder")} />;
        }


        const colSpan1 = Math.floor(this.props.cols / 2);
        const colSpan2 = ((this.props.cols / 2) % 1) !== 0 ? colSpan1 + 1 : colSpan1;

        return (
            <tr className={`trackingNotesRow ${this.props.className}`}>
                <td colSpan={colSpan1} style={{ verticalAlign: "top" }}>
                    <div className="d-flex">
                        <div className="acc-link p-2" onClick={this.onNewClick}>New</div>
                        <div className="flex-fill p-2">
                            {newNote}
                            {fileNotes}
                        </div>
                    </div>
                </td>
                <td colSpan={colSpan2} style={{ verticalAlign: "top" }}>
                    {alerts}
                    {this.props.notesText}
                </td>
            </tr>
        );

    }

}



export class InLineFileNotes extends React.Component {

    constructor(props) {
        super(props);

        this.clearNoteKey = 0;

        this.state = {
            showNewNote: false
        };

        this.onBlur = this.onBlur.bind(this);
        this.keyPress = this.keyPress.bind(this);
        this.onNewClick = this.onNewClick.bind(this);
    }

    onBlur() {
        this.setState({ showNewNote: false });

    }

    onNewClick() {
        this.setState({ showNewNote: true });
    }

    keyPress(event) {
        if (event.charCode === 13) {
            var val = event.currentTarget.value

            if (!accentUtils.isEmpty(val)) {
                this.props.onNew(val);
                this.setState({ showNewNote: false });
            }
        }
    }


    render() {


        if (!this.props.show)
            return null;



        if (accentUtils.isNull(this.props.notes)) {
            return <div className="trackingNotesRow">
                <AccentSpinner />
            </div>;
        }



        var fileNotes = null;
        if (!accentUtils.isNull(this.props.notes)) {
            fileNotes = this.props.notes.map(function (n) {
                return <div key={n.ID} className="accentTrackingNoteFileNote">
                    <div>{format.formatDateTime(n.Date, true, true) + ' ' + n.Representative}</div>
                    <div dangerouslySetInnerHTML={{ __html: n.Notes }} />
                </div>;
            });
        }
        var newNote = null;

        if (this.state.showNewNote) {
            newNote = <Input onBlur={this.onBlur} onKeyPress={this.keyPress} key={this.clearNoteKey} type="text" placeholder={t("application_strings.views.tracking.newNotePlaceholder")} />;
        }

        
        return (
            <div className="trackingFileNoteContainer">
                {this.props.onNew && <div>
                    <div className="acc-link" onClick={this.onNewClick}>New</div>
                </div>} 
                <div>
                    {newNote}
                    {fileNotes}
                </div>
            </div>
        );

    }

}